export default "__VITE_ASSET__BIzBtcfA__"